import { dateFns as moment } from '@pcln/date-fns-utils'
import get from 'lodash/get'
import pick from 'lodash/pick'
import querystring from 'query-string'

export function generateFlexDatesQuery({
  requestObj = {},
  rangePlusMinus = 3,
  rangePlus = 0,
  rangeMinus = 0,
  requestId,
  isLoggingRequest = false,
  fareType = 'RETAIL',
}) {
  const cabinClass = get(requestObj, 'params[cabin-class]', 'ECO')

  const passengerUrl = querystring.stringify(
    pick(requestObj.params, ['num-adults', 'num-children', 'num-infants'])
  )

  const defaultQueryOptions = {
    slices: [],
    rangePlusMinus,
    airports: {},
    // 720 is higher than the max 500 on APG side, this enables LD to control size on APG
    size: isLoggingRequest ? 180 : 720,
    useLOS: false,
    useCurrentDateReference: false,
    rangePlus,
    rangeMinus,
    requestId,
    fareType,
  }

  const query = buildElasticSearchQuery({
    ...defaultQueryOptions,
    ...{
      slices: requestObj.slices,
      rangePlusMinus,
      airports: requestObj.airports || {},
    },
    isLoggingRequest,
  })
  query.cabinClass = cabinClass

  return {
    query,
    passengerUrl,
  }
}

export function buildElasticSearchQuery(options) {
  const {
    slices,
    rangePlusMinus,
    rangePlus,
    rangeMinus,
    airports,
    size,
    useLOS,
    useCurrentDateReference,
    requestId,
    isLoggingRequest,
    fareType,
  } = options

  let departDate = null

  const trips = slices.map((slice, index) => {
    const returnMap = {}

    if (airports[slice.originAirport] && airports[slice.originAirport].cityCode === slice.originAirport) {
      returnMap.originCity = [slice.originAirport]
    } else {
      returnMap.origin = [slice.originAirport]
    }

    if (
      airports[slice.destinationAirport] &&
      airports[slice.destinationAirport].cityCode === slice.destinationAirport
    ) {
      returnMap.destinationCity = [slice.destinationAirport]
    } else {
      returnMap.destination = [slice.destinationAirport]
    }

    if (index === 0 || !useLOS) {
      departDate = slice.travelDate
      let rangeDate = departDate
      if (useCurrentDateReference) {
        const currentDate = moment().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0)
        const diff = moment(slice.travelDate).diff(currentDate, 'days')
        rangeDate =
          diff >= rangePlusMinus
            ? slice.travelDate
            : currentDate.add(rangePlusMinus, 'days').format('YYYY-MM-DD')
      }

      returnMap.departDateRange = {
        fromDate: rangeDate,
        rangePlusMinus,
        rangePlus,
        rangeMinus,
      }
    } else {
      const lengthOfStay = moment(slice.travelDate).diff(departDate, 'days')
      returnMap.lengthOfStay = [lengthOfStay]
    }

    return returnMap
  })

  return {
    trips,
    size,
    consumer: isLoggingRequest ? 'PCLN-FLIGHTS-LOGGING' : 'PCLN-FLIGHTS',
    requestId,
    fareType,
  }
}

export function numberOfViewersQuery({ cityCode, airportCode, travelDate }) {
  const flexDatesQuery = {
    trips: [
      {
        originCity: ['*'],
        departDate: travelDate,
      },
    ],
    size: 180,
    consumer: 'PCLN-FLIGHTS',
  }

  if (cityCode !== airportCode) {
    flexDatesQuery.trips[0].destination = [airportCode]
  } else {
    flexDatesQuery.trips[0].destinationCity = [cityCode]
  }

  return flexDatesQuery
}
